import { AxiosRequestHeaders } from "axios";

type Props = {
  pagination: {
    page: number;
    amount: number;
    itemsFound: number;
    total: number;
  };
  loadList: (module: string, headers: AxiosRequestHeaders) => Promise<void>;
  module: string;
  findHeaders: {
    Authorization: string;
    operation: string;
  };
};

export const Pagination: React.FC<Props> = ({
  pagination,
  loadList,
  module,
  findHeaders,
}) => {
  const groupPagesSize = 10;
  const totalPages = Math.ceil(pagination.total / pagination.amount);

  const totalPagesMultiple =
    Math.ceil(totalPages / groupPagesSize) * groupPagesSize;
  const lastPageMultiple =
    Math.ceil(pagination.page / groupPagesSize) * groupPagesSize;

  const firstPage = lastPageMultiple - 9;
  const lastPage =
    lastPageMultiple > totalPages ? totalPages : lastPageMultiple;

  const totalGroupPages = totalPagesMultiple / groupPagesSize;
  const currentPageGroup = Math.ceil(pagination.page / groupPagesSize);

  const firstItem = (pagination.page - 1) * pagination.amount + 1;
  const lastItem =
    pagination.itemsFound < pagination.amount
      ? pagination.page * pagination.amount -
        (pagination.amount - pagination.itemsFound)
      : pagination.page * pagination.amount;

  const pageLinks = [];

  for (let i = firstPage; i <= lastPage; i++) {
    pageLinks.push(
      <li
        key={i}
        className={`page-item ${i === pagination.page ? "active" : ""}`}
      >
        <a
          href="/"
          className="page-link"
          onClick={(event) => {
            event.preventDefault();
            Paginate(i);
          }}
        >
          {i}
        </a>
      </li>
    );
  }

  const Paginate = (page: number) => {
    pagination.page = page;

    loadList(module, findHeaders);
  };

  return (
    <div>
      <div className="d-flex justify-content-center align-items-center py-2">
        <ul className="pagination">
          {currentPageGroup > 1 && (
            <li className="page-item previous">
              <a href="/" className="page-link">
                <i className="previous"></i>
              </a>
            </li>
          )}
          {pageLinks}
          {currentPageGroup < totalGroupPages && (
            <li className="page-item next">
              <a href="/" className="page-link">
                <i className="next"></i>
              </a>
            </li>
          )}
        </ul>
      </div>
      <div
        className="fs-7 fw-bold text-gray-700 py-3"
        style={{ textAlign: "right" }}
      >
        <div>
          Itens por página:{" "}
          <span className="bg-primary p-1 text-white">
            {pagination.amount ?? 0}
          </span>
        </div>
        <div>
          Mostrando{" "}
          <span className="text-primary">
            {isNaN(firstItem) ? 1 : firstItem}
          </span>{" "}
          a{" "}
          <span className="text-primary">{isNaN(lastItem) ? 1 : lastItem}</span>{" "}
          de <span className="text-primary">{pagination.total ?? 0}</span> itens
        </div>
      </div>
    </div>
  );
};
